export default {
  namespaced: true,
  state: {
    user: {
      isLogged: false,
      name: null,
      email: null,
      status: null,
      id: null,
      type: null,
    },
    selectedUser: null,
  },
  getters: {
    isUserEmail: (state) => {
      return state.user.email;
    }
  },
  mutations: {
    loginUser(state, payload) {
      state.user.isLogged = true;
      state.user.token = payload.jwt;
      state.user.name = payload.name;
      state.user.email = payload.email;
      state.user.status = payload.status;
      state.user.id = payload.id;
      state.user.type = payload.type;
      localStorage.lbToken = payload.jwt;
      localStorage.lbEmail = payload.email;
    },
    logoutUser(state) {
      state.user.isLogged = false;
      state.user.token = null;
      state.user.name = null;
      state.user.email = null;
      state.user.status = null;
      state.user.id = null;
      state.user.type = null;
      localStorage.removeItem("lbToken");
      localStorage.removeItem("lbEmail");
    },
    validateUser(state, payload) {
      state.user.isLogged = true;
      state.user.token = localStorage.lbToken;
      state.user.name = payload.name;
      state.user.email = payload.email;
      state.user.status = payload.status;
      state.user.id = payload.id;
      state.user.type = payload.type;
    },
    setStatus(state, payload) {
      localStorage.removeItem("lbToken");
      localStorage.lbToken = payload.jwt;
      state.user.token = payload.jwt;
      state.user.status = payload.status;
    },
    clearUserData(state) {
      state.user.isLogged = false;
      state.user.token = null;
      state.user.name = null;
      state.user.email = null;
      state.user.status = null;
      state.user.id = null;
      state.user.type = null;
    },
    setSelectedUser(state, user) {
      state.selectedUser = user;
    },
    clearSelectedUser(state) {
      state.selectedUser = null;
    },
  },
  actions: {
    loginUser({ commit }, payload) {
      commit("loginUser", payload);
    },
    logoutUser({ commit }) {
      commit("logoutUser");
    },
    // Новое действие для инициализации состояния
    async initializeAuth({ commit }) {
      const token = localStorage.getItem("lbToken");
      const email = localStorage.getItem("lbEmail");

      if (token && email) {
        // Если есть токен и email, предполагаем, что пользователь авторизован
        // Здесь можно добавить запрос к API для проверки токена
        const payload = {
          jwt: token,
          email: email,
          name: null, // Можно заполнить через API
          status: null, // Можно заполнить через API
          id: null, // Можно заполнить через API
          type: null, // Можно заполнить через API
        };

        commit("validateUser", payload);
      } else {
        // Если токена или email нет, очищаем данные пользователя
        commit("clearUserData");
      }
    },
  },
  modules: {},
};
